import { Accordion } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SelectBox from "elements/SelectBox";
import InputBox from "elements/InputBox";
import Pagination from "elements/Pagination";
import DateSelector from "elements/DateSelector";
import NoRecordsFound from "elements/NoRecordsFound";
import DOMPurify from "dompurify";
import { Button, Modal } from "react-bootstrap";
import api from "services/api";
import Translator, { __ } from "services/Translator";
import PageHeadline from "../PageHeadline";

export default function Messages(props) {
  const defaultForm = {
    page: 1,
    triggerSearch: true,
  };
  const [results, setResults] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [pagination, setPagination] = useState([]);
  const updateForm = (value, field) => {
    setForm({ ...form, [field]: value });
  };

  const getResults = async () => {
    props.setSpinner(true);
    var response = await api.post("/player/messages", form);
    props.setSpinner(false);
    if (response.status === 200) {
      setResults(response.data.data);
      setPagination(response.data.paginationData);
    } else {
      props.showAlert(null, response.data.message, true);
    }
    updateForm(false, "triggerSearch"); //Ready for next trigger
  };

  useEffect(() => {
    if (form.triggerSearch) {
      getResults();
    }
  }, [form.triggerSearch]);

  const onPageChange = (page) => {
    setForm({ ...form, page: page, triggerSearch: true });
  };

  const deleteItem = async (itemId) => {
    if (window.confirm("Confirm deletion?")) {
      var response = await api.post("/player/message/delete", {
        id: itemId,
      });
      props.showAlert(null, response.data.message, response.status !== 200);
      getResults();
    }
  };

  const [fullMessage, setFullMessage] = useState(null);
  const showItem = async (message) => {
    setFullMessage(message);
    var response = await api.post("/player/message/mark-read", {
      id: message.id,
    });
    if (response.status !== 200) {
      props.showAlert(null, response.data.message, true);
    }
    getResults();
  };

  return (
    <>
      <PageHeadline page_name={__("Messages")} />

      <div className="page_content_area">
        <div className="table_area">
          <div className="d-block player_message_container">
            {results.length ? (
              <>
                {results.map((item, index) => (
                  <ul className="notifications-list">
                    {results.map((val, index) => (
                      <li key={index} className="message-item">
                        <div className="message-from">
                          <b>{__("From")}: </b>
                          {val.sender_name} {__("on")} {val.added_time}
                        </div>
                        <h4>
                          {__("Subject")}:{val.message_subject}
                          {!val.message_was_read && (
                            <>
                              <i className="fa fa-envelope unread_mark"></i>
                            </>
                          )}
                        </h4>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              val.message_body.substr(0, 150)
                            ),
                          }}
                        ></p>

                        <Link
                          hrefLang={Translator.getSelectedLanguage().code}
                          to="#"
                          className="open-modal white"
                          onClick={() => showItem(val)}
                        >
                          {__("Read More")}
                        </Link>

                        <Link
                          hrefLang={Translator.getSelectedLanguage().code}
                          to="#"
                          onClick={() => deleteItem(val.id)}
                          className="delete_msg"
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </Link>
                      </li>
                    ))}
                  </ul>
                ))}

                <Pagination data={pagination} onPageChange={onPageChange} />
              </>
            ) : (
              <NoRecordsFound />
            )}
          </div>
        </div>
      </div>
      {fullMessage && (
        <Modal
          className="modal"
          show={fullMessage}
          size="lg"
          onHide={() => setFullMessage(null)}
        >
          <Modal.Body className="player_message_modal">
            <div
              onClick={() => setFullMessage(null)}
              className="modal_close_reg small"
            >
              <svg
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.26872 8.99995L1.05492 3.59305C0.775612 3.3034 0.589405 2.86892 0.589405 2.43443C0.589405 1.99995 0.775612 1.56547 1.05492 1.27581C1.66009 0.648226 2.68423 0.648226 3.2894 1.27581L8.5032 6.68271L13.717 1.27581C14.3222 0.648226 15.3463 0.648226 15.9515 1.27581C16.2308 1.56547 16.417 1.99995 16.417 2.43443C16.417 2.86892 16.2308 3.3034 15.9515 3.59305L10.7377 8.99995L15.9515 14.4068C16.2308 14.6965 16.417 15.131 16.417 15.5655C16.417 15.9999 16.2308 16.4344 15.9515 16.7241C15.6722 17.0137 15.2532 17.2068 14.8342 17.2068C14.4153 17.2068 13.9963 17.0137 13.717 16.7241L8.5032 11.3172L3.2894 16.7241C2.68423 17.3517 1.66009 17.3517 1.05492 16.7241C0.775612 16.4344 0.589405 15.9999 0.589405 15.5655C0.589405 15.131 0.775612 14.6965 1.05492 14.4068L6.26872 8.99995Z"
                  fill="#10294F"
                />
              </svg>
            </div>

            <div className="modal_headline">{__("Message")}</div>
            <div className="message-from">
              <b>{__("From")}: </b>
              {fullMessage.sender_name} {__("on")} {fullMessage.added_time}
            </div>
            <strong>
              {__("Subject")}:{fullMessage.message_subject}
            </strong>
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(fullMessage.message_body),
              }}
            ></p>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
